import * as React from "react";

export const Table2ColumnPaddingContext = React.createContext<string | undefined>(undefined);

export function useTable2ColumnPadding(): string | undefined {
    return React.useContext(Table2ColumnPaddingContext);
}
